<template>
    <div>
        <div class="head">
            <img :src="bannerS" class="img100" alt="">
            <!-- <div class="head_banner_box">
                <div class="widthBox">
                    <div class="head_banner">
                        <img v-if="web_info.web_info" :src="web_info.web_info.web_header_logo_url" class="img100" alt="">
                        <div class="title mb_40">{{$t("BUILD YOUR TOMORROW,TODAY")}}</div>
                        <a class="btn radius-4" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a>
                    </div>
                </div>
            </div> -->
        </div>
        
        <div class="widthBox mb_40">
            <el-row :gutter="10" class="acea-row mt_120">
                <el-col :span="12" :xs="24" class="hidden-sm-and-up">
                    <img class="img100 radius-8" :src="setting_list.financial_year_plan_url" alt="">
                </el-col>
                <el-col :span="12" :xs="24" class="share_content" >
                    <div v-html="setting_list.share_content"></div>
                </el-col>
                <el-col :span="12" :xs="24" class="hidden-xs-only">
                    <img class="img100 radius-8" :src="setting_list.financial_year_plan_url" alt="">
                </el-col>
            </el-row>
       
        </div>
        
    <div class="widthBox banner mb_80 mt_80">
        <img src="@/assets/img_2.png" class="img100" alt="">
    </div>

    <div class="widthBox mb_48" v-if="list.length != 0">
        <p class="f-56 warn_txt">{{setting_list.title}}</p>
        <!-- <p class="f-40 warn_txt">{{ $t("WAYS TO") }} </p> -->
        <!-- <p class="f-72 mb_24">{{ $t("EARN") }}</p> -->
        <!-- <p class="info3 f-14">{{ $t("The Jeunesse Financial Rewards Plan is one of the most competitive compensation plans in the industry. Our Distributors are able to generate income in six different ways, earn luxury travel rewards and climb 15 prestigious achievement ranks.") }}</p> -->
    </div>
    <div v-for="(item,index) in list" :key="index" class="pd_bt_40" :class="(index + 2)%2 == 0 ? 'bg_f5' : ''">
        <div class="widthBox">
            <el-row :gutter="30" class="acea-row row-between">
                <el-col :span="12" :xs="24">
                    <div class="name mb_40"> <span>{{ index+1 }}</span> {{ item.name }}</div>
                    <div v-for="(item2,index2) in item.instruction_list" :key="index2" :class="(index2+1) != item.instruction_list.length ? 'mb_24' :'mb_00'">
                        <div class="txt mb_8">{{ item2.name
 }}</div>
                        <div class="info3 f-14">{{ item2.value }}</div>
                    </div>
                </el-col>
                <el-col :span="12" :xs="24">
                    <img :src="item.image_url_list[0]" class="img100" alt="">
                </el-col>
            </el-row>
        </div>
    </div>
    <div class="mt_80">
        <el-row :gutter="10" class="acea-row row-between">
            <el-col :span="14" :xs="24" class="txt_center">
                <!-- <p class="info3 f-14 mb_24">{{$t("Second knot, issued every week, explosive best-selling more than 10 countries in the world, all are your market. Truly global village, a mobile phone, a website to do global business.")}} </p> -->
                <p class="info f-20 mb_16">{{$t("Are you ready to get your reward?")}}</p>
                <div class="btn mb_24">
                    <a target="_blank" href="http://phromonglobal.com">{{$t("Join us and start earning rewards")}}</a>
                </div>
                <p class="info f-20 mb_16">{{ $t("Contact Us") }}</p>
                <ul style="width: 50%;text-align: left;margin: 0 auto;min-width:310px;">
                    <li>{{ $t("Enterprise email") }} ：{{ contact_us_info.products_after_sales_email }}</li>
                    <li>{{ $t("Products after-sales email") }}：{{ contact_us_info.enterprise_email }}</li>
                    <li>{{ $t("Member support email") }}：{{ contact_us_info.member_support_email }} </li>
                </ul>
            </el-col>
        </el-row>
    </div>

    
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            setting_list:[],
            list:[]
        }
    },
    computed: {
        ...mapState(['bannerS']),
        video() {
            return this.$store.state.video
        },
       
        web_info(){
            return this.$store.state.common
        },
        contact_us_info(){
            return this.$store.state.contact_us_info
        }
    },
    created() {
        // this.get_info();
        this.get_list()
    },
    methods: {
        async get_list(){
            let res = await this.$api.get("api/MemberCenter/financialRewards", this.query);
                this.setting_list = res.data.setting_list
                this.list = res.data.way_list || []
        },
        async get_info() {
            let res = await this.$api.get("api/Index/index", this.query);
        }
    }
}
</script>

<style lang="scss" scoped>

.footer {
    .btn {
        float: right;
        margin-top: 20px;
    }
}
.btn{
    padding: 12px 24px;
    // background: #B50900;
    a{
        padding: 12px 24px;
        background: #B50900;
        color: #Fff;
        font-size: 14px;
        border-radius: 8px;
    }
}
.pd_bt_40{
    padding-top: 40px;
    padding-bottom: 40px;
}
.bgf5 {
    background: #f5f5f5;
}

.pd_tb_40 {
    padding-top: 40px;
    padding-bottom: 40px;
}

.mt_20 {
    margin-top: 20px;
}

.mb_40 {
    margin-bottom: 40px;
}

.mt_80 {
    margin-top: 80px;
}

.mb_4 {
    margin-bottom: 4px;
}

.mb_8 {
    margin-bottom: 8px;
}

.mb_12 {
    margin-bottom: 12px;
}

.mb_16 {
    margin-bottom: 16px;
}

.mb_20 {
    margin-bottom: 20px;
}

.mb_24 {
    margin-bottom: 24px;
}
.mb_48{
    margin-bottom: 48px;
}
.mb_80{
    margin-bottom: 80px;
}
.f-40{
    font-size:40px;
}
.f-72{
    font-size: 72px;
    color: #1a1a1a;
}

.mt_120 {
    margin-top: 120px;
}

ul li {
    list-style: disc;
    color: #666666;
    font-size: 14px;
    position: relative;
    left: 16px;
    margin-bottom: 12px;
}

.btn {
    padding: 12px 24px;
    font-size: 14px;
    color: #Fff;
    background: #B50900;
    display: inline-block;
}

.head {
    position: relative;
    width: 100%;
    height: 100%;
    .head_banner_box{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0;
        .widthBox{
            position: relative;
            height: 100%;
        }
    }
    .head_banner {
        position: absolute;
        top: 20%;
        right: 0;
        background: #Fff;
        border-radius: 8px;
        padding: 40px;
        width: 30%;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;

        .img100 {
            padding: 0 45px;
            box-sizing: border-box;
            margin-bottom: 20px;
        }

        .title {
            color: #000;
            width: 100%;
        }
    }
}
.name{
    font-size: 28px;
    color: #40B4E5;
    display: flex;
    align-items: center;
    span{
        color: #fff;
        font-size: 20px;
        padding: 7px 15px;
        background: #40B4E5;
        margin-right: 16px;
    }
}
.bg_f5{
    background: #f5f5f5;
}

@media screen and(max-width:1000px) {
    .head_banner {
        top: 50% !important;
        left: 20px;
        box-sizing: border-box;
        padding: 20px !important;
        width: calc(100% - 40px) !important;
        box-shadow: 0px 5px 20px rgba($color: #000000, $alpha: 0.3);

        .img100 {
            padding: 0 180px !important;
        }

        div {
            width: 100%;
            padding: 0 180px !important;
        }
    }

    .mt_120 {
        margin-top: 250px;
    }
}

@media screen and(max-width:768px) {
    .head_banner {
        .img100 {
            padding: 0 15% !important;
        }

        div {
            width: 100%;
            padding: 0 15% !important;
            text-align: center;
        }
    }
    .mb_00{
        margin-bottom: 16px;
    }
    .txt {
        font-size: 14px !important;
    }

    .title {
        font-size: 20px !important;
    }

    .mb_4 {
        margin-bottom: 8px;
    }

    .mb_12 {
        margin-bottom: 16px;
    }

    .mt_80 {
        margin-top: 56px !important;
    }

    .f-20 {
        font-size: 14px;
    }

    .pd_tb_40 {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .mb_24 {
        margin-bottom: 16px;
    }

    .mb_40 {
        margin-bottom: 20px;
    }
    .mb_48{
    margin-bottom: 40px;
}
.mb_80 {
        margin-bottom: 24px;
    }
    .mt_120 {
        margin-top: 60px;
    }

    .footer {
        margin-bottom: 100px;
    }
    .pd_bt_40{
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .f-72{
        font-size: 28px;
        color: #4D4D4D;
    }
    .f-40{
        font-size: 14px;
    }
    .name{
        font-size: 20px;
        span{
            font-size: 14px;
            padding: 3px 8px;
        }
    }
}</style>